export const CLOSE_INSTALL_APP_BANNER = 'CLOSE_INSTALL_APP_BANNER' as const

export const closeInstallAppBannerAction = () => ({
  type: CLOSE_INSTALL_APP_BANNER,
})
